import {useTranslation} from 'react-i18next';

  
import {Box, Typography, Button} from '@mui/material';

 
import arrowEmpion100 from '../../../../../assets/job_postings/arrow_right_empion100.png';
import {greenColors} from '../../../../../layouts/theme/designSystem';

type JobPostingsCounterProps = {
  archived: number;
  active: number;
  selected: string | null;
  handleSelected: (selected: string) => void;
};

export default function JobPostingsCounter({archived, active, handleSelected, selected}: JobPostingsCounterProps) {
  const {t} = useTranslation();

  const counterButtonStyle = {
    textTransform: 'none',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    width: '130px',
    height: '30px',
  };

  const counterTypographyStyle = {
    paddingRight: '4px',
    color: greenColors[100],
  };

  const counterTypographyBody1Style = {
    color: greenColors[100],
  };

  return (
    <Box
      sx={{
        display: 'flex',
        marginTop: '12px',
        gap: '8px',
      }}
    >
      <Button onClick={() => handleSelected('active')} variant="text" sx={counterButtonStyle}>
        <Typography variant="h4" sx={counterTypographyStyle}>
          {active}
        </Typography>
        <Typography variant="body1" sx={counterTypographyBody1Style}>
          {t('companyJobPostings.jobHeader.active')}
        </Typography>
        <span>
          <Box
            component={'img'}
            src={arrowEmpion100}
            sx={{
              width: '7px',
              height: '10px',
              marginLeft: '4px',
              transform: selected === 'active' ? 'rotate(90deg)' : 'rotate(0)',
            }}
          />
        </span>
      </Button>
      <Button onClick={() => handleSelected('archived')} variant="text" sx={counterButtonStyle}>
        <Typography variant="h4" sx={counterTypographyStyle}>
          {archived}
        </Typography>
        <Typography variant="body1" sx={counterTypographyBody1Style}>
          {t('companyJobPostings.jobHeader.archived')}
        </Typography>
        <span>
          <Box
            component={'img'}
            src={arrowEmpion100}
            sx={{
              width: '7px',
              height: '10px',
              marginLeft: '4px',
              transform: selected === 'archived' ? 'rotate(90deg)' : 'rotate(0)',
            }}
          />
        </span>
      </Button>
    </Box>
  );
}
